import React, { useMemo, useState } from 'react'

import { Col, Row } from 'react-bootstrap'
import { Card, FormText, Select } from 'src/components'

import { IDataForm } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/CardPagaloForm'
import { ePayTypes } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/utils/TypePagaloBusiness'
import { commerceTypes } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/utils/CategoryPagaloBusiness'
import { selectGetAccounts } from 'src/selectors/banks.selector'
import { useSelector } from 'react-redux'
import { BankEnum } from 'src/enums/bankEnums'
import { ignoreAccountTypes } from 'src/enums/paymentTypes'

const types: ISelectString[] = ePayTypes.map(t => ({
  label: t.name,
  value: t.code,
}))

const categories: ISelectString[] = commerceTypes.map(c => ({
  label: c.name,
  value: c.code,
}))

export const PagaloBusiness = ({ data, setData, onChange }: IDataForm) => {
  const accounts = useSelector(selectGetAccounts)
  const bankAccounts: ISelectString[] = useMemo(
    () =>
      accounts
        .filter(a => !ignoreAccountTypes.includes(a.bank) && a.currency === 1)
        .map(a => ({
          label: a.name,
          value: a.id,
        })),
    [accounts],
  )

  return (
    <Card white title={'Comercio'}>
      <Row>
        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
          <FormText
            label={'Nombre del comercio'}
            value={data.nameBusiness}
            name={'nameBusiness'}
            required
            type={'text'}
            onChange={onChange}
          />
        </Col>
        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
          <Select
            label={'Categoría'}
            value={data.category}
            options={categories}
            required
            onChange={category => setData(prev => ({ ...prev, category }))}
          />
        </Col>
        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
          <Select
            label={'Tipo de comercio'}
            value={data.typeBusiness}
            options={types}
            required
            onChange={typeBusiness => setData(prev => ({ ...prev, typeBusiness }))}
          />
        </Col>
        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
          <Select
            label={'Cuenta bancaria'}
            value={data.bank}
            options={bankAccounts}
            required
            onChange={bank => setData(prev => ({ ...prev, bank }))}
          />
        </Col>
      </Row>
    </Card>
  )
}
